import React, { useEffect, useState, useRef } from "react";
import "../../css/custom.css";
import "../../css/style.css";
import { useAuthenticationContext } from "../../../Context/Authentication";
import { useInventoryProductContext } from "../../../Context/Cache/InventoryProductContext";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { useSearchContext } from '../../../Context/SetGlobalSearch';
import axios from "axios";
import { Pagination, ImageViewer } from "../../ExternalComponent";
import AlgopixUI from "../../AtuReplenishment/Atu/AlgopixUI";
import { useIncomingInventoryContext } from "../../../Context/Cache/IncomingInventory/IncomingInventoryContext";
import { Link, useLocation } from "react-router-dom"; // Amit
import { toast, ToastContainer } from "react-toastify";
import * as XLSX from "xlsx"; // Excel
import ExcelJS from 'exceljs';
import { FaFileExport } from "react-icons/fa6";
import newproductImage from '../../Assets/img/newProductImage.png';
import { FaSortUp, FaSortDown } from 'react-icons/fa';
import { FaSyncAlt } from "react-icons/fa";
import { strToU8, zipSync } from 'fflate';

const columns = [
  { key: "new", label: "", width: "0px", padding: "0px 2px" },
  { key: "image", label: "Image", width: "80px" },
  { key: "sku", label: "SKU", width: "80px" },
  { key: "brand", label: "Brand", width: "100px" },
  { key: "productName", label: "Product Name", width: "200px" },
  { key: "color", label: "Color", width: "70px" },
  { key: "size", label: "Size", width: "70px" },
  { key: "packaging", label: "Packaging", width: "80px" },
  { key: "upc", label: "UPC", width: "100px" },
  //{ key: "availableQuantity", label: "Available Quantity", width: "70px" },
  { key: "incomingQuantity", label: "Incoming Quantity", width: "70px" },
  { key: "requestedQuantity", label: "Requested Quantity", width: "100px" },
  { key: "price", label: "Price", width: "80px" },
  { key: "msrp", label: "MSRP", width: "80px" },
  { key: "counterOffer", label: "Offer Price", width: "100px" },
  { key: "masterCase", label: "Case Pack", width: "80px" },
  { key: "soldInEU", label: "Sold in EU", width: "70px" },
  { key: "expirationDate", label: "Expiration date", width: "100px" },
  { key: "batch", label: "Batch", width: "70px" },
];


const IncomingTable = () => {
  const {
    inventoryFilteredProducts,
    counterOffers,
    requestedQuantities,
    handleSelectedRowCheckboxChange,
    setRequestedQuantities,
    setCounterOffers,
    handleButtonClick,
    handleCloseClick,
    showPopup,
    algopixdata,
    amazonData,
    ebayData,
    walmartData,
    combinedSelectedItems, isRangeChanged, showApplyFilterOptions,
    exportExcelName, isExpanded, setIsExpanded,
    toggleWidth,
    isSelectAllChecked, setIsSelectAllChecked,
    fetchDataFromCache, fetchAndCacheData
    // handleProductCheckboxChange
  } = useIncomingInventoryContext();
  const { handleProductCheckboxChange, inputValues, setInputValues,
    handleCounterOfferChange, selectedRows, setSelectedRows, currentPath,
    setCurrentPath } = useCartInventoryContext();
  // const [visibleColumns, setVisibleColumns] = useState(
  //   columns.map((col) => col.key)
  // );
  const [visibleColumns, setVisibleColumns] = useState([
    "new", "image", "sku", "brand", "productName", "color", "size", "packaging", "upc",
    "availableQuantity", "requestedQuantity", "price", "msrp", "counterOffer", "incomingQuantity"]
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const { screenSize } = useAuthenticationContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [sortedExcelData, setSortedExcelData] = useState([])
  const [currentRecords, setCurrentRecords] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(100);
  const tableContainerRef = useRef(null);
  const [indexOfLastRecord, setIndexOfLastRecord] = useState(currentPage * recordsPerPage);
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(indexOfLastRecord - recordsPerPage);
  // const recordsPerPage = 100;
  const { searchTerm, setSearchResults } = useSearchContext();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefreshInventory = async () => {
    try {
      setRefreshing(true); // Session refresh Changes-Incoming-5

      const token = localStorage.getItem("120MinToken");

      if (!token) {
        toast.error("Token not found in localStorage. Session expired. Please login again.");
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/refresh-session`,
        { token }
      );

      if (!response.data.success) {
        throw new Error("Refresh failed");
      }

      localStorage.setItem("120MinToken", response.data.accessToken);

      // Fetch fresh inventory data from API and update cache with new products
      //const modifiedDate = new Date().toISOString();
      // await fetchAndCacheData(modifiedDate);

      await fetchDataFromCache();

      toast.success("Session refreshed & inventory updated");
    } catch (err) {
      console.error("Refresh error:", err);
      toast.error("Session expired. Please login again.");
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const newFilteredProducts = searchTerm
      ? inventoryFilteredProducts.filter(product =>
        (product.name && product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.nyc_brand && product.nyc_brand.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.nyc_upc && product.nyc_upc.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.productnumber && product.productnumber.toLowerCase().includes(searchTerm.toLowerCase()))
      )
      : inventoryFilteredProducts;
    setFilteredProducts(newFilteredProducts);
    setSearchResults(newFilteredProducts);
    setCurrentPage(1);
  }, [searchTerm, inventoryFilteredProducts]);

  const [sortConfig, setSortConfig] = useState({ key: 'brand', direction: 'asc' });
  const [maxHeight, setMaxHeight] = useState(`${screenSize.height - 270}px`);
  useEffect(() => {
    if (combinedSelectedItems.length > 0) {
      if (showApplyFilterOptions == true) {
        setMaxHeight(`${screenSize.height - 300}px`);
      } else {
        setMaxHeight(`${screenSize.height - 235}px`);
      }
    } else {
      setMaxHeight(`${screenSize.height - 280}px`);
    }
  }, [combinedSelectedItems, isRangeChanged, screenSize.height]);

  const columnKeyToRecordField = {
    brand: 'nyc_brand',
    sku: 'productnumber',
    productName: 'name',
    color: 'nyc_color',
    size: 'size',
    packaging: 'nyc_packaging',
    upc: 'nyc_upc',
    incomingQuantity: 'nyc_qtyonpo',
    requestedQuantity: 'requestedQuantity',
    price: 'price',
    msrp: 'nyc_msrp',
    counterOffer: 'counterOffer',
    masterCase: 'nyc_mastercasequantity',
    soldInEU: 'nyc_soldineurope',
    expirationDate: 'strava_expirationdate',
    batch: 'nyc_batchcode'
  }

  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const isNumeric = (value) => {
      return !isNaN(value) && !isNaN(parseFloat(value));
    };

    // Alphanumeric and numeric sort function
    const alphanumericSort = (a, b) => {
      if (!sortConfig.key) return 0; // No sorting if no column is selected

      const fieldKey = columnKeyToRecordField[sortConfig.key];

      // Get the values for comparison
      let valueA = a[fieldKey];
      let valueB = b[fieldKey];

      // Convert the values to numbers if they are numeric
      if (isNumeric(valueA) && isNumeric(valueB)) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);

        // Sort numeric values in descending order by default
        return sortConfig.direction === 'asc' ? valueB - valueA : valueA - valueB;
      }

      // If values are not numeric, treat them as strings
      valueA = valueA ? valueA.toString().toLowerCase() : '';
      valueB = valueB ? valueB.toString().toLowerCase() : '';

      // Regex to split numbers and non-numbers for alphanumeric sorting
      const regex = /(\d+|\D+)/g;

      const aParts = valueA.match(regex) || [];
      const bParts = valueB.match(regex) || [];

      for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
        const aPart = aParts[i];
        const bPart = bParts[i];

        // If both parts are numbers, compare them numerically
        if (!isNaN(aPart) && !isNaN(bPart)) {
          const diff = parseInt(aPart) - parseInt(bPart);
          if (diff !== 0) return sortConfig.direction === 'asc' ? diff : -diff;
        } else {
          // If parts are not numbers, compare them as strings
          if (aPart !== bPart) return sortConfig.direction === 'asc' ? aPart.localeCompare(bPart) : bPart.localeCompare(aPart);
        }
      }

      // If all parts are equal so far, compare by length of the split arrays
      return sortConfig.direction === 'asc' ? aParts.length - bParts.length : bParts.length - aParts.length;
    };


    // Sort products using the updated alphanumeric and numeric sort function
    const sortedFilteredProducts = [...filteredProducts].sort(alphanumericSort);

    // Other logic...
    // setIsSelectAllChecked(false);
    setSortedExcelData(sortedFilteredProducts);
    setCurrentRecords(sortedFilteredProducts.slice(indexOfFirstRecord, indexOfLastRecord));

    // Update previous values...


  }, [filteredProducts, currentPage, recordsPerPage, sortConfig]);

  const nPages = Math.ceil(filteredProducts.length / recordsPerPage);
  const toggleColumnVisibility = (key) => {
    setVisibleColumns((prevState) =>
      prevState.includes(key)
        ? prevState.filter((col) => col !== key)
        : [...prevState, key]
    );
  };

  const toggleAllColumns = () => {
    if (visibleColumns.length === columns.length) {
      setVisibleColumns([]);
    } else {
      setVisibleColumns(columns.map((col) => col.key));
    }
  };
  const isChecked = (product) => {
    return selectedProducts.some(p => p.nyc_upc === product.nyc_upc && p.productnumber === product.productnumber);
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setIsSelectAllChecked(isChecked);
    if (isChecked) {
      setSelectedProducts(filteredProducts);
      setSelectedRows(sortedExcelData);
    } else {
      setSelectedProducts([]);
      setSelectedRows([]);
    }
  };


  const handleProductCheckbox = (product, checked) => {
    setIsSelectAllChecked(false);
    handleProductCheckboxChange(product, checked);
    if (checked) {
      const updatedProduct = { ...product, incoming: true };

      setSelectedProducts(prev => {
        if (!prev.some(p => p.nyc_upc === product.nyc_upc && p.productnumber === product.productnumber)) {
          return [...prev, updatedProduct];
        }
        return prev;
      });
      setSelectedRows(prev => {
        if (!prev.some(p => p.nyc_upc === product.nyc_upc && p.productnumber === product.productnumber)) {
          return [...prev, updatedProduct];
        }
        return prev.map(item => item.nyc_upc === product.nyc_upc && item.productnumber === product.productnumber ? updatedProduct : item);
      });
    } else {
      setSelectedProducts(prev => prev.filter(p => !(p.nyc_upc === product.nyc_upc && p.productnumber === product.productnumber)));
      setSelectedRows(prev => prev.filter(p => !(p.nyc_upc === product.nyc_upc && p.productnumber === product.productnumber)));
    }
  };

  let previousError = null;
  const decimalPattern = /^(\d*\.{0,1}\d{0,2}$)/;
  const handleInputChange = (index, field, value) => {
    setCurrentRecords((prevRecords) => {
      const updatedRecords = [...prevRecords];
      const product = { ...updatedRecords[index] };

      if (field === "requestedQuantity") {
        if (value !== "" && (isNaN(value) || value < 0)) {
          product[field] = 0;
          const errorMessage = "Requested Quantity must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else if (value > parseInt(product.nyc_qtyonpo)) {
          product[field] = 0;
          const errorMessage =
            "Requested Quantity cannot be more than Incoming Quantity";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = parseInt(value, 10);
          previousError = null; // Clear previous error on valid input
        }
      } else if (field === "counterOffer") {
        if (value !== "" && (isNaN(value) || !value.match(decimalPattern))) {
          product[field] = 0;
          const errorMessage = "Counter Offer must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = formatCurrency(value);
          previousError = null; // Clear previous error on valid input
        }
      } else {
        if (value !== "" && (isNaN(value) || value <= 0)) {
          product[field] = 0;
          const errorMessage = "Value must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = parseInt(value, 10);
          previousError = null; // Clear previous error on valid input
        }
      }

      updatedRecords[index] = product;
      var isPresent = selectedRows.filter(item => item.nyc_upc === product.nyc_upc && item.productnumber === product.productnumber);

      if (isPresent.length === 0) {
        setSelectedRows(prev => [...prev, product]);
      }
      else {
        setSelectedRows(prev => prev.map(item => item.nyc_upc === product.nyc_upc && item.productnumber === product.productnumber ? product : item));
      }
      return updatedRecords;
    });
  };
  const formatCurrency = (value) => {
    // Remove any non-numeric characters except the decimal point
    value = value.replace(/[^\d.]/g, "");

    // Ensure two decimal places
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to the integer part

    // Limit to two decimal places
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
    }

    // Join integer and decimal parts
    value = parts.join(".");

    // Add dollar sign
    return `${value}`;
  };
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  useEffect(() => {
    if (pathnames != currentPath) {
      setIsSelectAllChecked(false)
      setSelectedRows([]);
      setCurrentPath(pathnames);
    }
  }, [])

  const toDataURL = (url, width = 70, height = 70) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const base64Url = canvas.toDataURL("image/jpeg");
        resolve({ base64Url });
      };
      img.onerror = function () {
        reject(new Error("Failed to load image at " + url));
      };
      img.src = url;
    });
  };

// const handleExcelExport = async (email) => {
//   // 1. Basic Validation
//   if (!selectedRows || selectedRows.length === 0) {
//     toast.warning("Please select some rows");
//     return;
//   }

//   const loadingToastId = toast.loading("Compressing data and starting export...");

//   try {
//     // 2. Prepare the data object using variables from your component scope
//     const payload = {
//       selectedRows,
//       visibleColumns,
//       email,
//       exportExcelName
//     };

//     // 3. Compress the JSON string into a Zip file in memory
//     const dataUint8 = strToU8(JSON.stringify(payload));
//     const compressed = zipSync({ "data.json": dataUint8 }, { level: 6 });

//     // 4. Wrap the compressed binary in FormData
//     const formData = new FormData();
//     // 'file' must match the backend upload.single('file')
//     formData.append("file", new Blob([compressed]), "data.zip");

//     // 5. POST to your Azure backend
//     await axios.post("https://nycdigitalcatalogue-uat-be.azurewebsites.net/api/data/export-products", formData, {
//       headers: { "Content-Type": "multipart/form-data" }
//     });

//     toast.dismiss(loadingToastId);
//     toast.success("Export started! You will receive an email shortly.");
//   } catch (error) {
//     toast.dismiss(loadingToastId);
//     console.error("Export Error:", error);
//     toast.error("Failed to send data to server.");
//   }
// };

   const handleExcelExport = async (email) => {
      // 1. Basic Validation
      if (!selectedRows || selectedRows.length === 0) {
        toast.warning("Please select some rows");
        return;
      }
    
      const loadingToastId = toast.loading("Compressing data and starting export...");
    
      try {
        // 2. Prepare the data object using variables from your component scope
        const payload = {
          selectedRows,
          visibleColumns,
          email,
          exportExcelName
        };
    
        // 3. Compress the JSON string into a Zip file in memory
        const dataUint8 = strToU8(JSON.stringify(payload));
        const compressed = zipSync({ "data.json": dataUint8 }, { level: 6 });
    
        // 4. Wrap the compressed binary in FormData
        const formData = new FormData();
        // 'file' must match the backend upload.single('file')
        formData.append("file", new Blob([compressed]), "data.zip");
    
        // const UAT_URL = process.env.REACT_APP_SERVER_URL ? process.env.REACT_APP_SERVER_URL : "http://localhost:4002";
        const PROD_URL = process.env.REACT_APP_SERVER_URL;
  
        await axios.post(PROD_URL + "/api/data/export-products", formData, {
         headers: { "Content-Type": "multipart/form-data" }
        });
    
        toast.dismiss(loadingToastId);
        toast.success("Export started! You will receive an email shortly.");
      } catch (error) {
        toast.dismiss(loadingToastId);
        console.error("Export Error:", error);
        toast.error("Failed to send data to server.");
      }
    };

  // const handleExcelExport = async (email) => {
  //   if (!visibleColumns.includes("image")) {
  //     toast.warning("Image column is hidden, please select it to proceed");
  //     return;
  //   }

  //   if (!selectedRows || selectedRows.length === 0) {
  //     toast.warning("Please select some rows");
  //     return;
  //   }

  //   // 1. Show loading toast immediately
  //   const loadingToastId = toast.loading(
  //     `Downloading images for ${selectedRows.length} products, please wait...`
  //   );

  //   try {
  //     // const imageBase64Map = await downloadImagesInBatches(selectedRows, 100);
  //     // console.log("All images downloaded:", Object.keys(imageBase64Map).length);

  //     const data = selectedRows.map((item) => {
  //       const tempArray = {};

  //       if (visibleColumns.includes("image")) tempArray.Image = "";
  //       if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
  //       if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
  //       if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
  //       if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
  //       if (visibleColumns.includes("size")) tempArray["Size"] = item.size + " " + item.nyc_sizeuom;
  //       if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
  //       if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
  //       if (visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
  //       if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity ?? "-";
  //       if (visibleColumns.includes("price")) tempArray.Price = `$${item.price.toFixed(2)}`;
  //       if (visibleColumns.includes("msrp")) tempArray.MSRP = `$${item.nyc_msrp.toFixed(2)}`;
  //       if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : `$${Number(item.counterOffer).toFixed(2)}`;
  //       if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
  //       if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
  //       if (visibleColumns.includes("expirationDate")) tempArray["Expiration Date"] = item.strava_expirationdate;
  //       if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

  //       return tempArray;
  //     });

  //     const workbook = new ExcelJS.Workbook();
  //     const worksheet = workbook.addWorksheet('Sheet1');
  //     worksheet.views = [{ state: 'frozen', ySplit: 1 }];

  //     const headers = Object.keys(data[0]);
  //     worksheet.addRow(headers);


  //     data.forEach((item) => {
  //       worksheet.addRow(Object.values(item));
  //     });

  //     const headerRow = worksheet.getRow(1);
  //     headerRow.height = 33;
  //     headerRow.eachCell((cell) => {
  //       cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF973131' } };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: '000000' } },
  //         left: { style: 'thin', color: { argb: '000000' } },
  //         bottom: { style: 'thin', color: { argb: '000000' } },
  //         right: { style: 'thin', color: { argb: '000000' } },
  //       };
  //       cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //       cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
  //     });

  //     worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //       if (rowNumber > 1) {
  //         row.height = 80;
  //         row.eachCell({ includeEmpty: true }, (cell) => {
  //           cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
  //         });
  //       }
  //       row.eachCell({ includeEmpty: true }, (cell) => {
  //         cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  //         cell.border = {
  //           top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //           left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //           bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //           right: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //         };
  //       });
  //     });

  //     worksheet.columns.forEach((column, index) => {
  //       const header = headers[index];
  //       if (header === "Image") column.width = 18;
  //       else if (header === "SKU") column.width = 18;
  //       else if (header === "Brand") column.width = 18;
  //       else if (header === "Available Quantity") column.width = 16;
  //       else if (header === "Requested Quantity") column.width = 16;
  //       else if (header === "Product Name") column.width = 45;
  //       else if (header === "UPC") column.width = 18;
  //       else if (header === "Packaging") column.width = 16;
  //       else column.width = 14;
  //     });

  //     const base64Excel = await workbook.xlsx.writeBuffer().then((buffer) => {
  //       return btoa(
  //         new Uint8Array(buffer).reduce(
  //           (data, byte) => data + String.fromCharCode(byte), ""
  //         )
  //       );
  //     });

  //     const today = new Date();
  //     const pad = (num) => num.toString().padStart(2, "0");
  //     const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;
  //     const nowUtc = new Date().toISOString().replace(/[:.]/g, "-");
  //     const excelName = `${exportExcelName ?? "NewYorkCosmetics-ProductList"}-${formattedDate}-${nowUtc}.xlsx`;

  //     // const payload = {
  //     //   filename: excelName,
  //     //   useremail: email,
  //     //   filecontent: base64Excel,
  //     //   imageMapJson: JSON.stringify(imageBase64Map),
  //     // };

  //     const imageArray = selectedRows.map(item => {
  //       const productNumber = item.productnumber || "placeholder";
  //       return `${productNumber}`;
  //     });

  //     // const imageColumnMap = selectedRows.map(item => {
  //     //   const productNumber = item.productnumber || "placeholder";

  //     //   return {
  //     //     sku: productNumber,
  //     //     url: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${productNumber}.jpg`
  //     //   };
  //     // });

  //     // console.log("imageArray", imageColumnMap);

  //     const payload = {
  //       filename: excelName,
  //       useremail: email,
  //       filecontent: base64Excel,
  //       imageMapJson: JSON.stringify(imageArray)
  //     };

  //     console.log("payload:", payload);

  //     toast.dismiss(loadingToastId);
  //     toast.success("Preparing your download, please check your email shortly.");

  //     // await axios.post(
  //     //   "https://575ccdcd21a7ec52a3593016dfabe6.11.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/9693170a3c394725a9f84fe372769c5d/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=xAwEW5_cS0iVxzAwC-Ob2Paz-NrAcFpf_SowNRbncFo%22,
  //     //   payload,
  //     //   { headers: { "Content-Type": "application/json" } }
  //     // );

  //     await axios.post(
  //       "https://575ccdcd21a7ec52a3593016dfabe6.11.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/3586754819bd4090a4089ed5265931f7/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=S2PF2pgvMPcOCbsO3YYLYBYydV7UIzjqP8-h6QU5a08",
  //       payload,
  //       { headers: { "Content-Type": "application/json" } }
  //     );

  //     console.log("Export complete.");
  //   } catch (error) {
  //     toast.dismiss(loadingToastId);
  //     toast.error("Export failed. Please try again.");
  //     console.error("Export error:", error);
  //   }

  // };

  // const handleExcelExport = async () => {

  //   const data = selectedRows.map((item) => {
  //     var tempArray = {};
  //     if(visibleColumns.includes("image")) tempArray.Image = {
  //       text: 'Image Link',
  //       hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`
  //     }
  //     if(visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
  //     if(visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
  //     if(visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
  //     if(visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
  //     if(visibleColumns.includes("size")) tempArray["Size(with UOM)"] = item.size + item.nyc_sizeuom;
  //     if(visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
  //     if(visibleColumns.includes("upc"))  tempArray.UPC = item.nyc_upc;
  //     if(visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
  //     if(visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity==undefined?"-":item.requestedQuantity;
  //     if(visibleColumns.includes("price")) tempArray.Price = `$${(item.price).toFixed(2)}`;
  //     if(visibleColumns.includes("msrp")) tempArray.MSRP =`$${(item.nyc_msrp).toFixed(2)}`;
  //     if(visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer==undefined?"-":item.counterOffer;
  //     if(visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
  //     if(visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] =  item.nyc_soldineurope?"Yes" : "No";
  //     if(visibleColumns.includes("expirationDate"))  tempArray["Expiration Date"] = item.strava_expirationdate;
  //     if(visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

  //     return tempArray;
  // });
  //  console.log("excel data",data);
  //   // console.log("Data:",inventoryFilteredProducts);
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');
  //   if(data[0]==undefined){
  //     toast.warning("please select some rows");
  //     return;
  //   }
  //   const headers = Object.keys(data[0]);
  //   worksheet.addRow(headers);

  //   data.forEach((item) => {
  //     const row = worksheet.addRow(Object.values(item));
  //     if(headers.indexOf('Image')!=-1){
  //       const imageCell = row.getCell(headers.indexOf('Image') + 1);
  //       if (imageCell.value && imageCell.value.text === 'Image Link') {
  //         imageCell.font = { color: { argb: '550000FF' } , underline: 'single'};
  //       }
  //     }

  //   });
  //   const headerRow = worksheet.getRow(1);
  //   headerRow.height = 40;
  //   headerRow.eachCell((cell) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FF973131' },
  //     };
  //     cell.border = {
  //       top: { style: 'thin', color: { argb: '000000' } },
  //       left: { style: 'thin', color: { argb: '000000' } },
  //       bottom: { style: 'thin', color: { argb: '000000' } },
  //       right: { style: 'thin', color: { argb: '000000' } },
  //     }
  //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //     cell.font = {
  //       bold: true,
  //       size: 12,
  //       color: { argb: 'FFFFFFFF' },
  //     };
  //   });

  //   worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //     if (rowNumber > 1) {
  //       row.height = 70;
  //       row.eachCell({ includeEmpty: true }, (cell) => {
  //         cell.fill = {
  //           type: 'pattern',
  //           pattern: 'solid',
  //           fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
  //         };
  //       });
  //     }
  //     row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true  };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: '000000' } },
  //         left: { style: 'thin', color: { argb: '000000' } },
  //         bottom: { style: 'thin', color: { argb: '000000' } },
  //         right: { style: 'thin', color: { argb: '000000' } },
  //       };
  //     });
  //   });

  //   worksheet.columns.forEach(column => {
  //     let maxLength = 0;
  //     column.eachCell({ includeEmpty: true }, (cell) => {
  //       if (cell.value) {
  //         const cellValue = cell.value.toString();
  //         maxLength = Math.max(maxLength, cellValue.length);
  //       }
  //     });
  //     column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  //   });

  //   const packagingColumnIndex = headers.indexOf('Packaging') + 1;
  //   const column = worksheet.getColumn(packagingColumnIndex);
  //   if (column) {
  //       column.width = 15;
  //   }
  //   const today = new Date();
  //   const pad = (num) => num.toString().padStart(2, '0');
  //   const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

  //   workbook.xlsx.writeBuffer().then((data) => {
  //     const blob = new Blob([data], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const anchor = document.createElement('a');
  //     anchor.href = url;
  //     anchor.download = `${exportExcelName==null?"NewYorkCosmetics-IncomingProductList":exportExcelName}-${formattedDate}.xlsx`;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //     window.URL.revokeObjectURL(url);
  //   });
  // };


  //orginal
  // const handleExcelExport = async (email) => {

  //   if (!visibleColumns.includes("image")) {
  //     toast.warning("Image column is hidden, please select it to proceed");
  //     return;
  //   }

  //   const data = selectedRows.map((item) => {
  //     var tempArray = {};
  //     // if (visibleColumns.includes("image")) tempArray.Image = `https://nycdatastorage.blob.core.windows.net/compressproduct-uatcontain/${item.productnumber || 'placeholder'}.jpeg`;
  //     if (visibleColumns.includes("image")) {
  //       const imageUrl = `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`;
  //       tempArray.Image = {
  //         formula: `_xlfn.IMAGE("${imageUrl}", 1)`,
  //         result: ""
  //       };
  //     }
  //     if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
  //     if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
  //     if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
  //     if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
  //     if (visibleColumns.includes("size")) tempArray["Size"] = item.size + " " + item.nyc_sizeuom;
  //     if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
  //     if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
  //     if (visibleColumns.includes("incomingQuantity")) tempArray["Incoming Quantity"] = item.nyc_qtyonpo;
  //     if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
  //     if (visibleColumns.includes("price")) tempArray.Price = `$ ${parseFloat(item.price).toFixed(2)}`;
  //     if (visibleColumns.includes("msrp")) tempArray.MSRP = `$ ${parseFloat(item.nyc_msrp).toFixed(2)}`;
  //     if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : `$${Number(item.counterOffer).toFixed(2)}`
  //     if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
  //     if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
  //     if (visibleColumns.includes("expirationDate"))
  //       if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

  //     return tempArray;
  //   });
  //   if (data[0] == undefined) {
  //     toast.warning("please select some rows");
  //     return;
  //   }

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');
  //   worksheet.views = [{ state: 'frozen', ySplit: 1 }];
  //   const headers = Object.keys(data[0]);
  //   worksheet.addRow(headers);

  //   data.forEach((item) => {
  //     const row = worksheet.addRow(Object.values(item));
  //     if (headers.indexOf('Image') != -1) {
  //       const imageCell = row.getCell(headers.indexOf('Image') + 1);
  //       if (imageCell.value && imageCell.value.text === 'Image Link') {
  //         imageCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //   });
  //   const headerRow = worksheet.getRow(1);
  //   headerRow.height = 33;
  //   headerRow.eachCell((cell) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FF973131' },
  //     };
  //     cell.border = {
  //       top: { style: 'thin', color: { argb: '000000' } },
  //       left: { style: 'thin', color: { argb: '000000' } },
  //       bottom: { style: 'thin', color: { argb: '000000' } },
  //       right: { style: 'thin', color: { argb: '000000' } },
  //     }
  //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //     cell.font = {
  //       bold: true,
  //       size: 12,
  //       color: { argb: 'FFFFFFFF' },
  //     };
  //   });

  //   worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //     if (rowNumber > 1) {
  //       row.height = 80;
  //       row.eachCell({ includeEmpty: true }, (cell) => {
  //         cell.fill = {
  //           type: 'pattern',
  //           pattern: 'solid',
  //           // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
  //           fgColor: 'FFFFFFFF'
  //         };
  //       });
  //     }
  //     row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //         left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //         bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //         right: { style: 'thin', color: { argb: 'FFE5E7EB' } },
  //       };
  //     });
  //   });

  //   // worksheet.columns.forEach(column => {
  //   //   let maxLength = 0;
  //   //   column.eachCell({ includeEmpty: true }, (cell) => {
  //   //     if (cell.value) {
  //   //       const cellValue = cell.value.toString();
  //   //       maxLength = Math.max(maxLength, cellValue.length);
  //   //     }
  //   //   });
  //   //   column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  //   // });

  //   // const packagingColumnIndex = headers.indexOf('Packaging') + 1;
  //   // const column = worksheet.getColumn(packagingColumnIndex);
  //   // if (column) {
  //   //   column.width = 15;
  //   // }

  //   // // set Image column width
  //   // const imageColumnIndex = headers.indexOf('Image') + 1;
  //   // const imagecolumn = worksheet.getColumn(imageColumnIndex);
  //   // if (imagecolumn) {
  //   //   imagecolumn.width = 12;
  //   // }

  //   worksheet.columns.forEach((column, index) => {
  //   const header = headers[index];

  //   if (header === "Image") column.width = 18;
  //   else if (header === "SKU") column.width = 18;
  //   else if (header === "Brand") column.width = 18;
  //   else if (header === "Available Quantity") column.width = 16;
  //   else if (header === "Requested Quantity") column.width = 16;
  //   else if (header === "Product Name") column.width = 45;
  //   else if (header === "UPC") column.width = 18;
  //   else if (header === "Packaging") column.width = 16;
  //   else if (header === "Incoming Quantity") column.width = 16;
  //   else column. Width = 14;
  // });

  //   const today = new Date();
  //   const pad = (num) => num.toString().padStart(2, '0');
  //   const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

  //   // Write the workbook to a buffer and convert to Base64
  //   const base64Excel = await workbook.xlsx.writeBuffer().then((buffer) => {
  //     return btoa(
  //       new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
  //     );
  //   });


  //   let excelName = `${exportExcelName == null ? "NewYorkCosmetics-IncomingProductList" : exportExcelName}-${formattedDate}.xlsx`;
  //   console.log("Excel Name:", excelName);
  //   //  console.log( base64Excel); // Store or send this Base64 as needed

  //   // const payload = {
  //   //   fileName: excelName,
  //   //   emailAddress: email,
  //   //   fileContent: base64Excel
  //   // };

  //   const payload = {
  //     filename: excelName,
  //     useremail: email,
  //     filecontent: base64Excel
  //   };

  //   toast.success("Preparing your download, please check your email shortly.");

  //   // console.log("endpoint: "+process.env.REACT_APP_UAT_AZURE_EXPORT_EXCEL_FUNCTION_ENDPOINT);
  //   axios.post(
  //     process.env.REACT_APP_SEND_EXPORT_EXCEL,
  //     payload,
  //     {
  //       headers: {
  //         "Content-Type": "application/json"
  //       }
  //     }
  //   )
  //     .then((response) => {
  //       console.log(response.data);
  //       // toast.success("Excel sent to " + email);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });

  //   // workbook.xlsx.writeBuffer().then((data) => {
  //   //   const blob = new Blob([data], {
  //   //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //   //   });
  //   //   const url = window.URL.createObjectURL(blob);
  //   //   const anchor = document.createElement('a');
  //   //   anchor.href = url;
  //   //   anchor.download = `${exportExcelName==null?"NewYorkCosmetics-IncomingProductList":exportExcelName}-${formattedDate}.xlsx`;
  //   //   document.body.appendChild(anchor);
  //   //   anchor.click();
  //   //   document.body.removeChild(anchor);
  //   //   window.URL.revokeObjectURL(url);
  //   // });
  // };

  const handleExcelExportWithoutImage = async () => {

    if (!visibleColumns.includes("image")) {
      toast.warning("Image column is hidden, please select it to proceed");
      return;
    }

    const data = selectedRows.map((item) => {
      var tempArray = {};
      if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
      if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
      if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
      if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
      if (visibleColumns.includes("size")) tempArray["Size"] = item.size + " " + item.nyc_sizeuom;
      if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
      if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
      if (visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
      if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
      if (visibleColumns.includes("price")) tempArray.Price = `$${(item.price).toFixed(2)}`;
      if (visibleColumns.includes("msrp")) tempArray.MSRP = `$${(item.nyc_msrp).toFixed(2)}`;
      if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : `$${Number(item.counterOffer).toFixed(2)}`
      if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
      if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
      if (visibleColumns.includes("expirationDate")) tempArray["Expiration Date"] = item.strava_expirationdate;
      if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

      return tempArray;
    });
    console.log("excel data", data);
    // console.log("Data:",inventoryFilteredProducts);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.views = [{ state: 'frozen', ySplit: 1 }];
    if (data[0] == undefined) {
      toast.warning("please select some rows");
      return;
    }
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    data.forEach((item) => {
      const row = worksheet.addRow(Object.values(item));

    });
    const headerRow = worksheet.getRow(1);
    headerRow.height = 33;
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF973131' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = {
        bold: true,
        size: 12,
        color: { argb: 'FFFFFFFF' },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.height = 70;
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
            fgColor: { argb: 'FFFFFFFF' },
          };
        });
      }
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
        };
      });
    });

    worksheet.columns.forEach((column, index) => {
      const header = headers[index];

      if (header === "Image") column.width = 18;
      else if (header === "SKU") column.width = 18;
      else if (header === "Brand") column.width = 18;
      else if (header === "Available Quantity") column.width = 16;
      else if (header === "Requested Quantity") column.width = 16;
      else if (header === "Product Name") column.width = 45;
      else if (header === "UPC") column.width = 18;
      else if (header === "Packaging") column.width = 16;
      else if (header === "Incoming Quantity") column.width = 16;
      else column.Width = 14;
    });
    const today = new Date();
    const pad = (num) => num.toString().padStart(2, '0');
    const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${exportExcelName == null ? "NewYorkCosmetics-ProductList" : exportExcelName}-${formattedDate}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  };

  const [showExportExcelPopup, setShowExportExcelPopup] = useState(false);
  const [exportExcelEmail, setExportExcelEmail] = useState("");
  const [exportExcelError, setExportExcelError] = useState("");
  const [includeImage, setIncludeImage] = useState("Yes");

  // Function to handle "OK" button click
  const handleExportExcelOkClick = () => {
    if (!exportExcelEmail) {
      setExportExcelError("Email is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(exportExcelEmail)) {
      setExportExcelError("Invalid email format");
    } else {
      setExportExcelError("");
      handleExcelOpenClosePopup(false)
      console.log("email: " + exportExcelEmail);
      includeImage == "Yes" ? handleExcelExport(exportExcelEmail) : handleExcelExportWithoutImage();
    }
  };

  // Function to close the popup
  const handleExcelOpenClosePopup = (value) => {
    if (value) {
      let email = getEmail();
      console.log("existing user email: " + email);
      if (email != null) {
        setExportExcelEmail(email);
      }
      setShowExportExcelPopup(true);
      setExportExcelError("");
    } else {
      setShowExportExcelPopup(false);
      setExportExcelError("");
    }

  };

  // get Existing user email
  function getEmail() {
    // Step 1: Check if EmailResponse is present in localStorage
    const emailResponse = localStorage.getItem("EmailResponse");

    if (emailResponse) {
      try {
        // Step 2: Parse the JSON string to an object
        const emailResponseObj = JSON.parse(emailResponse);

        // Step 3: Check if email exists in the parsed object
        if (emailResponseObj && emailResponseObj.email) {
          return emailResponseObj.email;
        }
      } catch (error) {
        console.error("Error parsing EmailResponse:", error);
      }
    }

    // Step 4: If no email found in EmailResponse, check NewUserEmail
    const newUserEmail = localStorage.getItem("NewUserEmail");

    if (newUserEmail) {
      return newUserEmail;
    }

    // Step 5: If no email found, return null
    return null;
  }


  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setSelectedProducts([]);
    setSelectedRows([]);
    setIsSelectAllChecked(false); // Reset checkbox state
  };
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl); // Set the selected image URL
    setIsModalOpen(true); // Open the modal
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedImage(null); // Reset the selected image URL
  };
  return (
    <div className="order-lg-2 min-w-full" style={{ maxWidth: isExpanded ? `${screenSize.width - 80}px` : `${screenSize.width - 345}px` }}>
      <ToastContainer />
      {showExportExcelPopup && (
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10 "
        >
          <div
            className="bg-white p-8 rounded-lg shadow-lg w-400"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
          >


            {/* Image Input */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-1">
                Include Image:
              </label>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="includeImage"
                    value="Yes"
                    checked={includeImage === "Yes"}
                    onChange={(e) => setIncludeImage(e.target.value)}
                    className="mr-2"
                  />
                  Yes
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="includeImage"
                    value="No"
                    checked={includeImage === "No"}
                    onChange={(e) => setIncludeImage(e.target.value)}
                    className="mr-2"
                  />
                  No
                </label>
              </div>
            </div>
            {/* Email Input */}
            {includeImage == "Yes" &&
              <>
                <label className="block text-gray-700 font-medium mb-1">Enter Your Email:</label>
                <input
                  type="email"
                  value={exportExcelEmail}
                  onChange={(e) => setExportExcelEmail(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded mb-2"
                  placeholder="example@example.com"
                  required
                />
              </>
            }

            {/* Error Message */}
            {exportExcelError && <p className="text-red-500 mb-4">{exportExcelError}</p>}

            {/* OK Button */}
            <button
              onClick={handleExportExcelOkClick}
              className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 mr-2"
            >
              OK
            </button>

            {/* Close Button */}
            <button
              onClick={() => setShowExportExcelPopup(false)}
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center nycfix-product-space">
        <h6 className="font-bold py-2">Products ({filteredProducts.length})</h6>
        <div className="flex gap-2">
          <button
            onClick={handleRefreshInventory}
            disabled={refreshing}
            className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
          >
            <FaSyncAlt />
            {refreshing ? "Refreshing..." : ""}
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
            onClick={() => handleExcelOpenClosePopup(true)}
          >
            <FaFileExport />
          </button>
          <div
            className="dropdown-container"
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <button className="dropdown-button flex items-center gap-2 px-2 font-bold py-2 bg-white-600 text-black text-sm rounded-md">
              Hide/Show Column
              {/* <PiColumnsPlusLeftFill  /> */}
            </button>
            {showDropdown && (
              <div className="dropdown-content flex gap-3">
                <div>
                  <input
                    type="checkbox"
                    className="mr-3"
                    checked={visibleColumns.length === columns.length}
                    onChange={toggleAllColumns}
                  />
                  Select All
                </div>
                <div>
                  {columns.map((col) => col.key !== "new" ? (
                    <div className="flex gap-2" key={col.key}>
                      <input
                        type="checkbox"
                        className="mr-3"
                        checked={visibleColumns.includes(col.key)}
                        onChange={() => toggleColumnVisibility(col.key)}
                      />
                      {col.label}
                    </div>
                  ) : <></>)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        ref={tableContainerRef}
        className="table-container box-border shadow-sm background-white max-h-screen overflow-auto nycfix-table-container"
        // style={{ maxHeight: `${screenSize.height - 310}px` }}
        style={{ maxHeight: maxHeight }}
      >
        <table className="table-fixed min-w-full" style={{ position: "relative" }}>
          <thead>
            <tr>
              <th className="w-10">
                <input
                  type="checkbox"
                  id="selectAllProducts"
                  checked={isSelectAllChecked}
                  onChange={handleSelectAllChange}
                />
              </th>
              {columns.map(col => (
                visibleColumns.includes(col.key) && (
                  <th
                    key={col.key}
                    style={{ width: col.width, padding: col.padding }}
                    onClick={col.key !== 'image' ? () => handleSort(col.key) : undefined}
                    className={col.key !== 'image' ? "cursor-pointer" : ""}
                  >
                    {col.label} {sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                  </th>
                )
              ))}
            </tr>
          </thead>
          <tbody >
            {currentRecords.map((product, index) => (
              <tr
                key={index}
                className={"bg-white"}
                style={{ borderBottom: "1px solid #E5E7EB" }}
              >
                {/* Amit 02-08-2024 */}
                <td>
                  <input
                    type="checkbox"
                    onChange={(e) => handleProductCheckbox(product, e.target.checked)}
                    checked={selectedRows.some(obj => obj.nyc_upc === product.nyc_upc && obj.productnumber === product.productnumber)}
                  />
                </td>
                <td style={{ position: "absolute", width: "40px", left: "21px" }}>
                  {product.nyc_receivedinlast30days === true ? <img src={newproductImage} /> : <></>}
                </td>
                {/* {visibleColumns.includes("image") && (
                  <td className="cursor-pointer">
                    <img
                      src={`https://nycdatastorage.blob.core.windows.net/compressproduct-uatcontain/${product.productnumber}.jpg`}
                      alt="Product"
                      className="w-16 h-16 object-cover"
                      style={{ padding: "5px 0px" }}
                      onClick={() =>
                        handleImageClick(
                          `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`
                        )
                      } // Pass image URL on click
                    />
                  </td>
                )} */}

                {visibleColumns.includes("image") && (
                  <td className="cursor-pointer" style={{ backgroundColor: "white" }}>
                    <div className="flex items-center justify-center" style={{ width: "64px", height: "64px", overflow: "hidden", backgroundColor: "white" }}>
                      <img
                        src={`https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`}
                        alt="Product"
                        className="max-w-full max-h-full object-contain"
                        loading="lazy"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          display: "block",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          handleImageClick(
                            `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`
                          )
                        }
                      />
                    </div>
                  </td>
                )}


                {visibleColumns.includes("sku") && (
                  <td className="text-[#DC0A0A]" style={{ fontWeight: 700 }}>{product.productnumber}</td>
                )}

                {visibleColumns.includes("brand") && (
                  <td>{product.nyc_brand}</td>
                )}

                {visibleColumns.includes("productName") && (
                  <td className="productName">{product.name}</td>
                )}

                {visibleColumns.includes("color") && (
                  <td>{product.nyc_color}</td>
                )}

                {visibleColumns.includes("size") && <td>{product.size}{" "}{product.nyc_sizeuom}</td>}

                {visibleColumns.includes("packaging") && (
                  <td>{product.nyc_packaging}</td>
                )}

                {visibleColumns.includes("upc") && (
                  <td>
                    {product.nyc_upc}

                  </td>
                )}

                {/*            
              {visibleColumns.includes("availableQuantity") && (
                <td>{product.strava_availablequantity}</td>
              )} */}
                {visibleColumns.includes("incomingQuantity") && (
                  <td>{product.nyc_qtyonpo}</td>
                )}
                {visibleColumns.includes("requestedQuantity") && (
                  <td>
                    <input
                      type="text"
                      value={product.requestedQuantity || ""}
                      onChange={(e) => handleInputChange(index, "requestedQuantity", e.target.value)}
                      className="width50"
                    />
                  </td>
                )}

                {visibleColumns.includes("price") && <td>{product["price@OData.Community.Display.V1.FormattedValue"]}</td>}

                {visibleColumns.includes("msrp") && <td>{product["nyc_msrp@OData.Community.Display.V1.FormattedValue"]}</td>}

                {visibleColumns.includes("counterOffer") && (
                  <td>
                    <input
                      type="text"
                      value={product.counterOffer || ""}
                      onChange={(e) => handleInputChange(index, "counterOffer", e.target.value)}
                      className="width50"
                    />
                  </td>
                )}

                {visibleColumns.includes("masterCase") && (
                  <td>{product.nyc_mastercasequantity}</td>
                )}
                {visibleColumns.includes("soldInEU") && (
                  <td>{product.nyc_soldineurope ? "Yes" : "No"}</td>
                )}
                {visibleColumns.includes("expirationDate") && (
                  <td>{product.strava_expirationdate}</td>
                )}
                {visibleColumns.includes("batch") && (
                  <td>{product.nyc_batchcode}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* AlgopixUi */}

      {showPopup && (
        <AlgopixUI
          handleClose={handleCloseClick}
          algopixdata={algopixdata}
          amazonData={amazonData}
          ebayData={ebayData}
          walmartData={walmartData}
        />
      )}

      {/* AlgopixUi change */}
      <div className="pagination-container">
        <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
      {/* Image Ui change */}
      {isModalOpen && selectedImage && (
        <div className="fixed z-10 inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded relative w-auto max-w-full">
            {/* Render the ImageViewer component */}
            <ImageViewer imageUrl={selectedImage} onClose={handleCloseModal} />
          </div>
        </div>
      )}
    </div>
  );
};

export default IncomingTable;